export default ({ store }) => {
  if (!store.getters['integrators/integratorListLoaded']) {
    return store
      .dispatch('integrators/loadIntegratorList')
      .catch(() => {})
  }
}
